
  export default {
    props: {
      cardProps: {
        type: Object,
        default: () => ({
          title: '',
          image: '',
          text: '',
          footer: {
            image: '',
            text: '',
            time: '',
            authorSlug: ''
          },
          link: '',
          badge: {
            category_description: '',
            category_path: ''
          }
        })
      }
    }
  };
